// MUI
import { styled } from "@mui/system";
import { Box, Grid, Typography } from "@mui/material";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";

// Hooks
import { useLocation } from "@Common/hooks/Location/useLocation";

// Helpers
import { getFormattedDate } from "@dealerwave/dw-layer-date-converter";

// Constants
import { DATE_FORMAT } from "@Constants/date";

// Types
import { ITimelineNode } from "@PayPlans/types/historical";

const CustomTimelineSeparator = styled(TimelineSeparator)(() => ({
	"& .css-1ami7lv-MuiTimelineConnector-root": {
		backgroundColor: "var(--primary-color)",
	},
}));

type TimelineProps = {
	nodeTimeLineList: ITimelineNode[];
	selectedIndex: number;
	setSelectedIndexParent: (index: number) => void;
};
export default function TimeLineHistory(props: TimelineProps) {
	const { nodeTimeLineList = [], selectedIndex = 0, setSelectedIndexParent } = props;

	const { timezone } = useLocation();

	const handleItemClick = (index: number) => {
		setSelectedIndexParent(index);
	};

	return (
		<Grid container direction="row" className="overflow-auto h-80">
			<Timeline
				sx={{
					[`& .${timelineItemClasses.root}:before`]: {
						flex: 0,
						padding: 0,
					},
				}}
			>
				{nodeTimeLineList.map((node, index) => {
					return (
						<TimelineItem
							key={node.planId + index}
							className={selectedIndex === index ? "ml-1" : "ml-2.5"}
							onClick={() => handleItemClick(index)}
						>
							<CustomTimelineSeparator>
								{selectedIndex === index ? (
									<TimelineDot variant="outlined" className={node.active ? "w-6 h-6 !border-primary" : "w-6 h-6"}>
										<TimelineDot className={node.active ? "!mt-0 !bg-primary" : "!mt-0"} />
									</TimelineDot>
								) : (
									<TimelineDot className={node.active ? "!bg-primary" : ""} />
								)}
								<TimelineConnector />
							</CustomTimelineSeparator>
							<TimelineContent>
								<Typography
									className={node.active ? "pay-plan-assign-history-title" : "pay-plan-assign-history-title-disable"}
									mt={0}
								>
									{getFormattedDate(node.assignmentDate, timezone, DATE_FORMAT.monthNameOrdinal)}
								</Typography>
								{selectedIndex === index ? (
									<Typography
										className={node.active ? "pay-plan-assign-history-text" : "pay-plan-assign-history-title-disable"}
										mt={1}
									>
										{node.assignmentDetails}
									</Typography>
								) : (
									<Box />
								)}
							</TimelineContent>
						</TimelineItem>
					);
				})}
			</Timeline>
		</Grid>
	);
}
